import React from "react";
import { Modal, Button } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";

/**
 * Persistent success acknowledgement after report submit (replaces auto-dismiss toast).
 * `pendingFileCount` — files still uploading in background; 0 hides the queue line.
 */
export default function SubmissionSuccessModal({ show, onHide, pendingFileCount = 0 }) {
  const hasUploads = pendingFileCount > 0;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="submission-success-modal"
      backdropClassName="submission-success-modal__backdrop"
      contentClassName="submission-success-modal__content"
      dialogClassName="submission-success-modal__dialog"
      aria-labelledby="submission-success-modal-title"
    >
      <Modal.Body className="submission-success-modal__body">
        <div className="submission-success-modal__icon-wrap" aria-hidden>
          <CheckCircleFill className="submission-success-modal__check" />
        </div>
        <h2 id="submission-success-modal-title" className="submission-success-modal__title">
          Επιτυχής Υποβολή!
        </h2>
        <p className="submission-success-modal__message">
          {hasUploads ? (
            <>
              Η αναφορά σας αποθηκεύτηκε. Τα αρχεία (φωτογραφίες/βίντεο) μεταφορτώνονται τώρα στο
              παρασκήνιο. Μπορείτε να συνεχίσετε στην επόμενη εργασία.
            </>
          ) : (
            <>
              Η αναφορά σας αποθηκεύτηκε. Μπορείτε να συνεχίσετε στην επόμενη εργασία.
            </>
          )}
        </p>
        {hasUploads ? (
          <p className="submission-success-modal__status" role="status">
            Σε αναμονή:{" "}
            <strong>
              {pendingFileCount} {pendingFileCount === 1 ? "αρχείο" : "αρχεία"}
            </strong>
          </p>
        ) : null}
        <Button
          type="button"
          variant="primary"
          className="submission-success-modal__btn"
          onClick={onHide}
        >
          Εντάξει
        </Button>
      </Modal.Body>
    </Modal>
  );
}
